module.exports = __webpack_public_path__ + "account/assets/yappy.de6a6e61.svg";